import { useSyncExternalStore } from "react";

/** El access vive únicamente en este módulo; nunca se serializa en storage. */
let tokenEnMemoria: string | null = null;
let inicializando = true;
let inicializacion: Promise<void> | null = null;
const escuchas = new Set<() => void>();
let snapshot = { autenticado: false, inicializando: true };

function notificar(): void {
  snapshot = { autenticado: estaAutenticado(), inicializando };
  for (const escucha of escuchas) escucha();
}

export function iniciarSesion(token: string): void {
  tokenEnMemoria = token;
  inicializando = false;
  notificar();
}

export function cerrarSesion(): void {
  tokenEnMemoria = null;
  inicializando = false;
  notificar();
}

export function obtenerAccess(): string | null {
  return tokenEnMemoria;
}

export function estaAutenticado(): boolean {
  return tokenEnMemoria !== null;
}

/** Restaura la sesión desde la cookie httpOnly una vez al cargar la SPA. */
export function inicializarSesion(): Promise<void> {
  if (inicializacion) return inicializacion;
  inicializacion = fetch("/api/v1/auth/refresh", { method: "POST", credentials: "include" })
    .then(async (respuesta) => {
      const datos = (await respuesta.json().catch(() => ({}))) as { access?: string };
      if (respuesta.ok && datos.access) tokenEnMemoria = datos.access;
    })
    .catch(() => undefined)
    .finally(() => {
      inicializando = false;
      notificar();
    });
  return inicializacion;
}

/** Añade el bearer desde memoria sin exponerlo a componentes o storage. */
export function fetchAutenticado(url: string, opciones: RequestInit = {}): Promise<Response> {
  const headers = new Headers(opciones.headers);
  if (tokenEnMemoria) headers.set("Authorization", `Bearer ${tokenEnMemoria}`);
  return fetch(url, { ...opciones, credentials: "include", headers });
}

function suscribirse(escucha: () => void): () => void {
  escuchas.add(escucha);
  return () => escuchas.delete(escucha);
}

export function useAutenticacion(): { autenticado: boolean; inicializando: boolean } {
  return useSyncExternalStore(
    suscribirse,
    () => snapshot,
    () => ({ autenticado: false, inicializando: false }),
  );
}

export function useEstaAutenticado(): boolean {
  return useAutenticacion().autenticado;
}
